export default {
  MfaContactSelectForm__CONTACT_REQUIRED: "Select a contact method.",
  MfaContactSelectForm__EMAIL_ACTION: "Email me a verification passcode at",
  MfaContactSelectForm__PHONE_DISCLAIMER: "(US domestic numbers only)",
  MfaContactSelectForm__PROMPT: "Where should we send your verification code?",
  MfaContactSelectForm__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.name} option selected. ${data.index} of ${data.length}`,
  MfaContactSelectForm__SMS_ACTION: "Text me a verification passcode at",
  MfaContactSelectForm__SUBMIT: "Continue",
  MfaContactSelectForm__TERMS_AGREE: "I agree to the",
  MfaContactSelectForm__TERMS_AGREE_NOT_VALID: "You must agree to the terms and conditions.",
  MfaContactSelectForm__TERMS_AGREE_REQUIRED: "You must agree to the terms and conditions.",
  MfaContactSelectForm__TERMS_AND_CONDITIONS: "terms and conditions.",
  MfaContactSelectForm__TERMS_AND_CONDITIONS_ARIA: "terms and conditions. opens new window",
};
